module.exports = __webpack_public_path__ + "2f0935fd63da7d428f3eaf2d7bbda281.pdf";